// extracted by mini-css-extract-plugin
export default {"wrapper":"TimePill_wrapper__WhtDP","blocked":"TimePill_blocked__ObsLd"};